// 加入我们页面内容
import { getPortalContents } from '@/api/portal'
import {
  groupJoinSections,
  normalizeJoinItems
} from '@/components/modules/join/utils/joinNormalize'

let joinFetchSeq = 0
let inflightJoinFetch = null

export default {
  namespaced: true,
  state: {
    philosophy: null,
    supplier: null,
    loading: false,
    loaded: false,
    locale: ''
  },
  getters: {
    philosophySection(state) {
      return state.philosophy
    },
    supplierSection(state) {
      return state.supplier
    },
    hasContent(state) {
      return Boolean(state.philosophy?.content || state.supplier?.content)
    }
  },
  mutations: {
    SET_SECTIONS(state, { philosophy, supplier, locale }) {
      state.philosophy = philosophy || null
      state.supplier = supplier || null
      state.loaded = true
      state.locale = locale || ''
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    RESET(state) {
      state.philosophy = null
      state.supplier = null
      state.loaded = false
      state.locale = ''
      state.loading = false
    }
  },
  actions: {
    async fetchJoin({ commit, dispatch, state, rootState }, options = {}) {
      const { force = false } = options ?? {}
      const locale = rootState.locale.current
      if (!locale) return

      if (!force && state.loaded && state.locale === locale) return

      if (force) {
        joinFetchSeq += 1
        inflightJoinFetch = null
      }

      if (inflightJoinFetch?.locale === locale && !force) {
        return inflightJoinFetch.promise
      }

      const seq = ++joinFetchSeq
      // task
      const task = (async () => {
        commit('SET_LOADING', true)
        try {
          const params = { type: 'INTRODUCTION', locale }
          if (force) params._t = Date.now()
          const [contents, menus] = await Promise.all([
            getPortalContents(params),
            dispatch('nav/ensureRawMenus', null, { root: true })
          ])
          if (seq !== joinFetchSeq) return

          const rootMenu = options?.rootMenu || null
          const items = normalizeJoinItems(contents, menus, rootMenu)
          if (!items.length) {
            commit('SET_SECTIONS', { philosophy: null, supplier: null, locale })
            return
          }

          const grouped = groupJoinSections(items)
          commit('SET_SECTIONS', { ...grouped, locale })
        } catch (error) {
          if (seq !== joinFetchSeq) return
          commit('SET_SECTIONS', { philosophy: null, supplier: null, locale })
          throw error
        } finally {
          if (seq === joinFetchSeq) {
            commit('SET_LOADING', false)
          }
        }
      })()

      inflightJoinFetch = { locale, promise: task }
      try {
        await task
      } finally {
        if (inflightJoinFetch?.promise === task) {
          inflightJoinFetch = null
        }
      }
    },
    reloadByPath({ dispatch }, payload) {
      const path = typeof payload === 'string' ? payload : payload?.path
      const force = typeof payload === 'object' && payload ? Boolean(payload.force) : false
      const rootMenu = typeof payload === 'object' && payload ? payload.rootMenu || null : null
      if (!path || !rootMenu) return Promise.resolve()
      return dispatch('fetchJoin', { force, rootMenu })
    }
  }
}
